angular.module 'zc.core'

.filter 'changeDatetimeFrom', (Project) ->
  (from, date, returnType = 'date', region) ->
    throw new TypeError("Please provide a valid 'from' value. #{from}") unless ['localToRegion', 'regionToLocal'].includes(from)

    return null unless date

    throw new TypeError('Please provide a date') if new Date(date).toString() == 'Invalid Date'

    region ||= Project.getRegion()

    throw new TypeError('Please provide a region') unless region

    if from == 'localToRegion'
      datetimeInBrowser = moment(date).format('YYYY-MM-DD HH:mm:ss')
      targetDatetime = moment.tz(datetimeInBrowser, region)
    else # regionToLocal
      datetimeInRegion = moment(date).tz(region).format('YYYY-MM-DD HH:mm:ss')
      targetDatetime = moment(datetimeInRegion, 'YYYY-MM-DD HH:mm:ss')

    return targetDatetime if returnType == 'moment'
    return targetDatetime.format() if returnType == 'string'
    return targetDatetime.valueOf() if returnType == 'integer'
    return targetDatetime.toDate()



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/change_datetime_from.filter.coffee